import styled from 'styled-components';
import { contentCentered } from 'helpers/styles.js';

export const NoProductsPageContainer = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.palette[0]};
  color: white;

  a {
    color: ${({ theme }) => theme.colors.palette[7]};
  }
  ${contentCentered};
`;

export const ErrorContainer = styled.div`
  white-space: pre;
  text-align: left;
  color: #fb1359;
  height: 200px;
  margin: 8px auto 24px;
  overflow: hidden;
`;
